import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const submitEventRsvp = makePieActionObjs("submit", "event_rsvp")

export const submitEventRsvpActionTypes = submitEventRsvp.pieDict
